import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import Button from '../button/Button.vue'
import Input from '../input/Input.vue'
import Modal from '@/components/Modal/Modal.vue'

type ConfirmationModalItem = string | { label: string; subItems?: string[] }


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    title: null,
    subtitle: null,
    items: null,
    loading: { type: Boolean },
    confirmationEmail: null
  },
  emits: ["cancel", "delete"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'cancel'): void
	(event: 'delete'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	title: string
	subtitle: string
	items: ConfirmationModalItem[]
	loading: boolean
	confirmationEmail?: string
};





const typedEmail = ref('')

const normalizedItems = computed(() =>
	props.items.map((item) =>
		typeof item === 'string'
			? { label: item, subItems: [] as string[] }
			: { label: item.label, subItems: item.subItems ?? [] },
	),
)

const requiresEmail = computed(
	() => props.confirmationEmail != null && props.confirmationEmail !== '',
)

const isDeleteDisabled = computed(
	() =>
		requiresEmail.value &&
		typedEmail.value.trim().toLowerCase() !== (props.confirmationEmail ?? '').trim().toLowerCase(),
)

return { __sfc: true,props, emit, typedEmail, normalizedItems, requiresEmail, isDeleteDisabled, Button, Input, Modal }
}

})